var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadableOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 24.9",
    style: {
      enableBackground: "new 0 0 26 24.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2FDA7B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9117974_download_iconeqwe",
    transform: "translate(-1.746 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,19.7C14.7,19.7,14.7,19.7,14.7,19.7L14.7,19.7c-0.1,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2c0,0,0,0,0,0 c0,0,0,0,0,0l-5.2-5.2c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.5,3.5V3c0-0.6,0.4-1,1-1s1,0.4,1,1v13.3l3.5-3.5c0.4-0.4,1-0.4,1.4,0 s0.4,1,0,1.4l-5.2,5.2c0,0,0,0,0,0c-0.1,0.1-0.2,0.2-0.3,0.2C15,19.7,14.9,19.7,14.7,19.7C14.8,19.7,14.8,19.7,14.7,19.7L14.7,19.7 C14.8,19.7,14.8,19.7,14.7,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,26.9c-1.7,0-3.1-1.1-3.5-2.8c0-0.1,0-0.2,0-0.2v-3.3c0-0.6,0.4-1,1-1s1,0.4,1,1v3.1 c0.2,0.7,0.8,1.1,1.5,1.1h19c0.7,0,1.3-0.5,1.5-1.1v-3.1c0-0.6,0.4-1,1-1s1,0.4,1,1v3.3c0,0.1,0,0.2,0,0.2 c-0.4,1.6-1.8,2.7-3.4,2.8H5.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadableOutline);
export default __webpack_public_path__ + "static/media/Downloadable-outline.194c5e2a98b8a6d0fcffd76cc436dd79.svg";
export { ForwardRef as ReactComponent };